export enum DoseType {
    None = 0,
    Skip = 1,
    Move = 2,
}